import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import { useDisabledOptions } from 'hooks/useDisabledOptions'
import { useCheckPermission } from 'hooks/useCheckPermission'
import { Permission } from '@cims-online/shared'
import { ReviewNotesFormItemProps } from './types'
import CIMSTextArea from 'components/CIMSTextArea'

const ReviewNotesFormItem: React.FC<ReviewNotesFormItemProps> = ({
  requiredMessage,
}) => {
  const [disabled, { some }] = useDisabledOptions([
    {
      reason: 'missing permission',
      disabled: !useCheckPermission(Permission.ReviewIdentifiedFieldIssue),
    },
  ])
  return (
    <CIMSFormItem
      requiredMessage={requiredMessage}
      name="reviewNotes"
      label="Review Notes"
      help={HelpMessage.IdentifiedFieldIssues.IFITracker.ReviewNotes}
      disabled={disabled}
    >
      <CIMSTextArea disabled={some} />
    </CIMSFormItem>
  )
}

export default ReviewNotesFormItem
